export default __webpack_public_path__ + "static/media/product-02 (2).3c26e45a.jpg";